<div class="container-fluid">
    <div class="row">
        <div [ngClass]="_leftColumn" class="overflow-auto">
            <ng-content select="[left]"></ng-content>
        </div>
        <div [ngClass]="_rightColumn" class="overflow-auto">
            <ng-content select="[right]"></ng-content>
        </div>
    </div>
</div>
